import { render, staticRenderFns } from "./fbtextbox.vue?vue&type=template&id=76adc5b4&"
import script from "./fbtextbox.vue?vue&type=script&lang=js&"
export * from "./fbtextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports